import { ListCheckbox, PictureView } from '@watersport/ui-react-icons'
import { Button, SwitchPrimitive } from '@watersport/ui-react-next'
import React from 'react'

import { cn } from 'features/common/helpers/cn'

interface ActivityModalHeaderProps {
  isGridView: boolean
  setIsGridView: (isGrid: boolean) => void
  selectedAll: boolean
  onCheckedChange: (status: boolean) => void
  locationId: string | undefined
  totalGroupCount: number | undefined
}

const ActivityModalHeader: React.FC<ActivityModalHeaderProps> = ({
  isGridView,
  setIsGridView,
  selectedAll,
  onCheckedChange,
  locationId,
  totalGroupCount,
}) => {
  return (
    <div className="flex items-center justify-between p-5 border-b border-blue-200 bg-blue-700">
      <div className="flex justify-start items-center gap-x-2.5">
        <span className="text-base-white">View</span>
        <div className="flex justify-center items-center h-10 space-x-2.5">
          <Button
            variant="ghost"
            className={cn(
              'h-10 px-2 rounded-lg border-none hover:bg-blue-500',
              isGridView && 'bg-blue-800',
            )}
            onClick={() => setIsGridView(true)}
            text={<PictureView width={24} height={24} className="text-white" />}
          />
          <Button
            variant="ghost"
            className={cn(
              'h-10 px-2 rounded-lg border-none hover:bg-blue-500',
              !isGridView && 'bg-blue-800',
            )}
            onClick={() => setIsGridView(false)}
            text={<ListCheckbox width={24} height={24} className="text-white" />}
          />
        </div>
      </div>
      <div className="flex gap-x-2.5">
        <h1 className={cn('text-base font-normal text-white', selectedAll && 'font-semibold')}>
          {locationId ? `Select all (${totalGroupCount || 0})` : 'Select all'}
        </h1>
        <SwitchPrimitive.Switch
          checked={selectedAll}
          onCheckedChange={onCheckedChange}
          checkedColor="bg-blue-900"
          uncheckedColor="bg-gray-300"
        />
      </div>
    </div>
  )
}

export default ActivityModalHeader
